// Single source of truth for the client-side password policy. Mirrors the backend
// (validate_password_policy in server.py): min 10 chars, max 72 UTF-8 bytes, no
// forced complexity, spaces/passphrases/unicode allowed, no silent truncation.
export const PW_MIN_LEN = 10;
export const PW_MAX_BYTES = 72;
export const pwByteLen = (s) => new TextEncoder().encode(s || '').length;

// Returns the i18n key of the first policy violation, or null if valid.
// currentPw / confirmPw are optional depending on the form.
export function pwPolicyError(newPw, { confirmPw, currentPw } = {}) {
  if (!newPw) return 'pw.errFillAll';
  if (newPw.length < PW_MIN_LEN) return 'pw.errMinLen';
  if (pwByteLen(newPw) > PW_MAX_BYTES) return 'pw.errMaxLen';
  if (currentPw !== undefined && newPw === currentPw) return 'pw.errSame';
  if (confirmPw !== undefined && newPw !== confirmPw) return 'pw.errMismatch';
  return null;
}
